<template>
  <div class="opc-cart__clear" v-if="is">
    <zm-button type="link" ghost aria-label="Remove all" @click="clear">{{ getSelectedPlans.length > 1 ? $t('billing.common.remove_all') : $t('billing.common.remove') }}</zm-button>
  </div>
</template>

<script>
import { planTypes } from '@/common/constants';
import { mapGetters, mapActions } from 'vuex';
import { isFromMarketingCampaign } from '../coupon/helper/utils';
import { modalHybrid } from '@/utils/modal-utils';
import { mapMutations } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getSelectedPlans']),
    is(){
      if (modalHybrid.isInWebview) return false;
      if (isFromMarketingCampaign()) return false;
      return this.getSelectedPlans.length && (this.$context.is.buyNow || this.$context.is.basic2pro)
    }
  },
  methods: {
    ...mapActions(['removePlanByKey']),
    ...mapMutations(['setDraftPlanFilterKeys']),
    clear() {
      this.getSelectedPlans.forEach((x) => {
        let key = planTypes.map([x.type])?.[0] ?? '';
        if (!key) return;
        this.removePlanByKey({
            key,
            force: true
        });
      });

      this.setDraftPlanFilterKeys([]); // there are invalidated plan cards

      this.$tracking.persistentCart('cart empty state - remove all');
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-cart__clear {
  text-align: center;
  padding-top: 16px;
}
</style>
